// Gelir ve gider tablolarının sütunları. Anahtarlar Budgets kayıtlarındaki alan
// adlarıdır (süzgeçler de bu anahtarlarla çalışır); `id`: budget.columns.<id>.
// Sıra eski tabloyla aynı, yalnızca satırı tanıtan Unvan başa alınıp sabitlendi.
// `kind` hücrenin nasıl yazılacağını söyler (BudgetCell).

/** Display value with a fallback chain, e.g. MusteriUnvan || BütçeKaynak (eski sayfadaki gibi). */
export const pick = (row, ...keys) => {
  for (const k of keys) {
    const v = row?.[k];
    if (v !== undefined && v !== null && v !== '') return v;
  }
  return '';
};

// Kayıtlı (Türkçe) durum değerleri → budget.status.<key>
export const STATUS_KEYS = {
  'Alındı': 'received',
  'Beklemede': 'pending',
  'Ödendi': 'paid',
  'İptal': 'cancelled',
  'Bekleyen': 'waiting',
  'Aktif': 'active',
  'Pasif': 'passive',
};

const buildColumns = (party) => {
  const isIncome = party === 'Musteri';
  return {
    [`${party}Unvan`]: { id: isIncome ? 'customerName' : 'senderName', type: 'select', kind: 'party', width: 280 },
    GibNumarasi: { id: 'gib', type: 'text', kind: 'code', width: 180 },
    TaslakNo: { id: 'draft', type: 'text', width: 150 },
    Senaryo: { id: 'scenario', type: 'select', width: 150 },
    FaturaTipi: { id: 'invoiceType', type: 'select', width: 160 },
    OlusturmaTarihi: { id: 'createdDate', type: 'date', kind: 'date', width: 200 },
    OlusturmaZamani: { id: 'createdTime', type: 'text', width: 200 },
    BelgeTarihi: { id: 'documentDate', type: 'date', kind: 'documentDate', width: 170 },
    BelgeZamani: { id: 'documentTime', type: 'text', width: 180 },
    [`${party}TcknVkn`]: { id: isIncome ? 'customerTax' : 'senderTax', type: 'text', width: 210 },
    [`${party}Etiketi`]: { id: isIncome ? 'customerTag' : 'senderTag', type: 'text', width: 190 },
    Tutar: { id: 'amount', type: 'text', kind: 'total', width: 150 },
    ParaBirimi: { id: 'currency', type: 'select', width: 150 },
    ZarfUuid: { id: 'envelopeUuid', type: 'text', kind: 'code', width: 170 },
    ZarfDurumu: { id: 'envelopeStatus', type: 'select', width: 180 },
    Ettn: { id: 'ettn', type: 'text', kind: 'code', width: 160 },
    Iskonto: { id: 'discount', type: 'text', kind: 'amount', width: 140 },
    FaturaDisiMasraflari: { id: 'extraCosts', type: 'text', kind: 'amount', width: 230 },
    SatirSayisi: { id: 'lineCount', type: 'text', kind: 'int', width: 160 },
    BirimFiyatMiktarTutari: { id: 'lineTotal', type: 'text', kind: 'amount', width: 270 },
    OdenecekTutar: { id: 'payable', type: 'text', kind: 'amount', width: 190 },
    VergilerHaricTutar: { id: 'taxExcluded', type: 'text', kind: 'amount', width: 220 },
    VergilerDahilTutar: { id: 'taxIncluded', type: 'text', kind: 'amount', width: 220 },
    'ÖdemeDurumu': { id: 'paymentStatus', type: 'select', kind: 'status', width: 170 },
  };
};

export const INCOME_COLUMNS = buildColumns('Musteri');
export const EXPENSE_COLUMNS = buildColumns('Gonderici');
/** Every filterable key of both tabs (filters are shared by the tabs, as before). */
export const ALL_COLUMNS = { ...INCOME_COLUMNS, ...EXPENSE_COLUMNS };

export const columnsFor = (tab) => (tab === 'gelir' ? INCOME_COLUMNS : EXPENSE_COLUMNS);
export const defaultVisible = (columns) => Object.fromEntries(Object.keys(columns).map((key) => [key, true]));
export const pinnedFor = (tab) => [tab === 'gelir' ? 'MusteriUnvan' : 'GondericiUnvan'];
export const MIN_COLUMN_WIDTH = 96;

// Eski tablodaki gibi her süzgeç yazıldığı anda uygulanır
export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
